import { utils } from '@tradetrust-tt/token-registry-v5';

const { encodeInitParams, getEventFromReceipt, computeInterfaceId } = utils;

export { computeInterfaceId, encodeInitParams, getEventFromReceipt };
